var exports = {
  "DZ": "Heading__HWVMb-",
  "az": "Box__P690hh",
  "wy": "Box_1__msrtHU",
  "pv": "Box_2__VIbiG6",
  "w9": "Box_3__oAH8Yn",
};

module.exports = exports;
